// Page videos and their posters live on Cloudflare Pages (project "proomtb-videos" in PROOMTB's
// Cloudflare account), not in public/, so the site's own server doesn't have to send them.
// In landingPages.json, videoFile and videoPoster are paths inside this CDN.
// To change a video, upload it there under a new file name: browsers keep each file for 30 days.
export const VIDEO_CDN = 'https://proomtb-videos.pages.dev';
